import { Directive, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { PreviewImageDialogComponent } from './preview-image-dialog.component';

@Directive({
  selector: '[appPreviewImages]',
})
export class PreviewImagesDirective {
  constructor(private readonly dialog: MatDialog) {}

  previewImage(element: HTMLImageElement) {
    const imageSrc = element.getAttribute('src');
    if (imageSrc) {
      this.dialog.open(PreviewImageDialogComponent, {
        data: imageSrc,
        maxWidth: '95vw',
      });
    }
  }

  @HostListener('click', ['$event.target'])
  click(element: HTMLImageElement | null) {
    if ('img' === element?.tagName.toLowerCase() && !element?.closest('a')) {
      this.previewImage(element);
      return false;
    }
  }
}
